import { render } from "./MobileBagtypeDialog.vue?vue&type=template&id=721b4400&scoped=true&ts=true"
import script from "./MobileBagtypeDialog.vue?vue&type=script&lang=ts"
export * from "./MobileBagtypeDialog.vue?vue&type=script&lang=ts"

import "./MobileBagtypeDialog.vue?vue&type=style&index=0&id=721b4400&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721b4400"]])

export default __exports__